export enum TempEmploymentReasonCode {
  AssignedWorkOrProject = "AssignedWorkOrProject", // "Määrätty työ tai projekti"
  ProductionPeak = "ProductionPeak", // "Tuotantohuippujen tasaaminen"
  Internship = "Internship", // "Työharjoittelu"
  Substitution = "Substitution", // "Sijaisuus"
  SpecificOrder = "SpecificOrder", // "Tietty tilaus"
  Season = "Season", // "Sesonki"
  OwnRequest = "OwnRequest", // "Oma pyyntö"
}
